<template>
	<div>
		<h4 class="section-title">Import HHAs for <span v-if="organization">{{ organization.name }}</span></h4>

		<p class="text-uppercase"><strong>Select program</strong></p>
		<div  class="white-content rounded mb-3 white-content p-3">
			<!--<div class="custom-popover  custom-popover-left popover-top">
				<div class="m-0">
					<div class=" m-0">
						<strong class="h5 m-0">STEP 2.</strong>
						<p> Select one of the existing programs</p>
					</div>
				</div>
			</div>-->
			<v-select class="mb-2"  :searchable="false" 
				v-model="courses_selected" :options="courses" multiple>
			</v-select>
		</div>
		
		<div class="checkbox-container squared mb-2">
			<input id="checkbox-send-welcome-sms" type="checkbox" v-model="send_welcome_sms_notif"/>
			<label for="checkbox-send-welcome-sms" style="width:auto;">Notify new HHAs</label>
		</div>

		<p class="text-uppercase"><strong>Import HHAs</strong></p>
		<vue-dropzone ref="dropzone" id="dropzone" class="mb-3"
    		:options="dropzoneOptions"
    		@vdropzone-success="fileUploaded" @vdropzone-file-added="fileAdded">
    	</vue-dropzone>

    	<a :href="`${api_base}NevvonSampleImportTemplate.xlsx`" class="text-underline">Click here to download template with dummy data</a>
	

    	<div v-if="import_result != null">
    		<h5>Results</h5>
    		<table  class="table table-bordered">
    			<thead>
    				<th class="green-content orderable">New HHAs</th>
    				<th class="green-content orderable">Already in the system</th>
    				<th class="green-content orderable">Errors</th>
    			</thead>
    			<tbody>
    				<tr>
    					<td>{{ import_result.unique_providers }}</td>
    					<td>{{ import_result.repeated_providers }}</td>
    					<td>{{ import_result.errors }}</td>
    				</tr>
    			</tbody>
    		</table>
    		<table  class="table table-bordered">
    			<thead>
    				<th class="green-content orderable">Row</th>
    				<th class="green-content orderable">Status</th>
    				<th class="green-content orderable">Errors</th>
    			</thead>
    			<tbody>
    				<tr v-for="row in import_result.logs">
    					<td>{{ row.index }}</td>
    					<td>{{ row.status }}</td>
    					<td>
    						<ul>
    							<li v-for="error in row.message">
    								{{ error }}
    							</li>
    						</ul>
    					</td>
    				</tr>
    			</tbody>
    		</table>
    	</div>
	</div>
</template>

<script>
	export default{
		data : function(){
			return {
				organization_id : this.$route.params.id,
				organization : null,
				dropzoneOptions: {
					url : this.config.UPLOAD_ORGANIZATION_PROVIDERS_CSV + '?organization_id='+this.$route.params.id,
					thumbnailWidth: 50,
					maxFilesize: 50,
					maxFiles : 1,
					addRemoveLinks : true,
					headers : {
						'Autrollization' : localStorage.getItem('token')
					}
			    },
			    message : '',
			    import_result : null,
			    courses : [],
				courses_selected : [],
				send_welcome_sms_notif : false,
				api_base : this.config.API_BASE
			}
		},

		created : function(){

			var params = {
				id : this.$route.params.id
			}

			this.getCourses();

			this.$store.dispatch('getOrganization', params).then((res) => {
				this.organization = res.data.data;
			}).catch((error) => {
				console.log(error);
			})
		},
		methods : {
			fileUploaded : function(file, response){
				console.log(response);
				this.message = response.message;
				this.import_result = response.import;
				this.$refs.dropzone.removeAllFiles();

				this.$router.push({
					name: 'admin.organizations.imports.detail', 
					params : { 
						id: this.organization_id, 
						import_id : response.import.id 
					}
				});

			},
			getCourses : function() {

				var params = {
					id : this.organization_id,
					filters : {
						to_select : true,
						per_page : 100,
					}
				}
				
				this.$store.dispatch('getOrganizationCourses', params).then((res) => {
					this.courses = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},
			fileAdded : function(file){

				var url = this.config.UPLOAD_ORGANIZATION_PROVIDERS_CSV+'?organization_id='+ this.organization_id+'&courses=';

				for(var i in this.courses_selected){
					url += this.courses_selected[i].value +',';
				}

				url += '&send_welcome_sms=' + (this.send_welcome_sms_notif ? 1 : 0);

				console.log(url);
				this.$refs.dropzone.setOption('url',url);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/AdminOrganizationImportProvidersComponent.vue